













































































import Vue from 'vue';
import axios from 'axios';

interface ICustomerRow {
    code: string;
    name: string;
    revenue_yesterday: number;
    pallets_yesterday: number;
    revenue_month: number;
    pallets_month: number;
}

interface IRawCustomerRow {
    code: string;
    name: string;
    revenue_yesterday: string;
    pallets_yesterday: string;
    revenue_month: string;
    pallets_month: string;
}

interface Column {
    title: string;
    field: keyof ICustomerRow;
}

const COLUMNS: Column[] = [
    {title: 'Customer', field: 'name'},
    {title: 'Revenue Yesterday', field: 'revenue_yesterday'},
    {title: 'Pallets Yesterday', field: 'pallets_yesterday'},
    {title: 'Revenue MTD.', field: 'revenue_month'},
    {title: 'Pallets MTD.', field: 'pallets_month'},
];

export default Vue.extend({
    name: 'DepotCustomerDashboard',
    props: {
        depot: String,
    },
    data() {
        return {
            customers: [] as ICustomerRow[],
            limit: 10,
            columns: COLUMNS,
            sortField: 'revenue_month' as keyof ICustomerRow,
            searchText: '',
        };
    },
    computed: {
        dataUrl(): string {
            const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
            return `${BASE_URL}/reports/dashboard/customer_stats/${this.depot}/`;
        },
        sortedCustomers(): ICustomerRow[] {
            const sorted = [...this.customers];
            sorted.sort((a, b) => {
                const aField = a[this.sortField];
                const bField = b[this.sortField];
                switch (typeof aField) {
                    case 'string':
                        return aField.localeCompare(bField.toString());
                    case 'number':
                        return (bField as number) - aField;
                }
            });
            return sorted;
        },
        filteredCustomers(): ICustomerRow[] {
            return this.sortedCustomers.filter((c) => c.name.toLowerCase().includes(this.searchText.toLowerCase()));
        },
        top(): ICustomerRow[] {
            return this.sortedCustomers.slice(0, this.limit);
        },
        bottom(): ICustomerRow[] {
            return this.sortedCustomers.slice(this.sortedCustomers.length - this.limit);
        },
    },
    watch: {
        depot: {
            immediate: true,
            async handler(depot) {
                const response = await axios.get<{ result: IRawCustomerRow[] }>(this.dataUrl);
                this.customers = response.data.result.map((x) => {
                    return {
                        ...x,
                        revenue_yesterday: parseFloat(x.revenue_yesterday),
                        pallets_yesterday: parseFloat(x.pallets_yesterday),
                        revenue_month: parseFloat(x.revenue_month),
                        pallets_month: parseFloat(x.pallets_month),
                    };
                });
            },
        },
    },
});
